var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-table',{attrs:{"flat":"","data":_vm.data,"pagination":_vm.quasarPagination,"columns":_vm.columns},scopedSlots:_vm._u([{key:"body-cell-action",fn:function(props){return [_c('q-td',{attrs:{"props":props}},[_c('c-btn',{attrs:{"flat":"","text-color":"red","label":"Cancel Plan"}})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }